// เสียงเตือนสไตล์ "อิคคิวซัง" — ป๊อก ป๊อก ป๊อก ... ติ๊ง! (เคาะปลาไม้ + ระฆังวัด ตอนนั่งสมาธิคิดออก)
// สังเคราะห์ด้วย Web Audio ไม่ใช้ไฟล์เสียง (ทำนองเพลงจริงมีลิขสิทธิ์ — ใช้เสียงวัด generic แทน)
// หมายเหตุ: เบราว์เซอร์บล็อกเสียงจนกว่าผู้ใช้จะคลิก — ปุ่มกระดิ่งคือ gesture ที่ปลดล็อก

let ctx = null;
function ac() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

// "ป๊อก" — เคาะปลาไม้ (โน้ตทุ้มสั้น pitch หล่นไว หางเสียงหด)
function pok(c, t, f = 640) {
  const o = c.createOscillator(), g = c.createGain();
  o.type = 'triangle';
  o.frequency.setValueAtTime(f, t);
  o.frequency.exponentialRampToValueAtTime(f * 0.55, t + 0.09);
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(0.45, t + 0.004);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
  o.connect(g).connect(c.destination);
  o.start(t); o.stop(t + 0.14);
}

// "ติ๊ง!" — ระฆังใสหางเสียงยาว (fundamental + overtone ไม่กลมกลืน เหมือนระฆังจริง)
function ting(c, t, f = 1975) {
  [[1, 0.2], [2.76, 0.08], [5.4, 0.025]].forEach(([m, v]) => {
    const o = c.createOscillator(), g = c.createGain();
    o.type = 'sine'; o.frequency.value = f * m;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(v, t + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 1.25);
    o.connect(g).connect(c.destination);
    o.start(t); o.stop(t + 1.35);
  });
}

// เตือนปกติ: ป๊อก ป๊อก ป๊อก ... ติ๊ง!
export function chime() {
  try {
    const c = ac(); if (!c) return false;
    const t0 = c.currentTime + 0.03;
    pok(c, t0); pok(c, t0 + 0.22); pok(c, t0 + 0.44);
    ting(c, t0 + 0.8);
    return true;
  } catch { return false; }
}

// เร่งด่วน: เคาะรัวกว่า + ติ๊งสองที (คิดออกเรื่องใหญ่!)
export function chimeUrgent() {
  try {
    const c = ac(); if (!c) return false;
    const t0 = c.currentTime + 0.03;
    [0, 0.13, 0.26, 0.39].forEach(d => pok(c, t0 + d, 680));
    ting(c, t0 + 0.64);
    ting(c, t0 + 1.0, 2349);
    return true;
  } catch { return false; }
}
